import { useState, useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import HomePage from './pages/Home'
import TransportPage from './pages/Transport'
import EquipmentPage from './pages/Equipment'
import EquipmentItemPage from './pages/EquipmentItem'
import AboutPage from './pages/About'
import ContactPage from './pages/Contact'
import AdminDashboard from './pages/AdminDashboard'
import LogisticsDashboard from './pages/LogisticsDashboard'
import ProjectManagerDashboard from './pages/ProjectManagerDashboard'
import WorkerDashboard from './pages/WorkerDashboard'
import PublicLayout from './layouts/PublicLayout'
import CareersPage from './pages/Careers'
import InvestmentPage from './pages/Investment'
import TechnologyPage from './pages/Technology'
import contentEn from './content.en'
import contentFr from './content.fr'
import './App.css'

const content = {
  en: contentEn,
  fr: contentFr
}

function readInitialLang() {
  try {
    const q = new URLSearchParams(window.location.search).get('lang')
    if (q === 'en' || q === 'fr') return q
    const saved = localStorage.getItem('go_lang')
    if (saved === 'en' || saved === 'fr') return saved
    if (typeof navigator !== 'undefined' && /^fr\b/i.test(navigator.language || '')) return 'fr'
  } catch (_) {}
  return 'en'
}

function App() {
  const year = new Date().getFullYear()
  const [lang, setLang] = useState(readInitialLang)
  const [equipmentItemsByLang, setEquipmentItemsByLang] = useState(() => ({
    en: content.en.equipment.items.map((item) => ({ ...item })),
    fr: content.fr.equipment.items.map((item) => ({ ...item }))
  }))
  const [uploadedItems, setUploadedItems] = useState(() => {
    const saved = localStorage.getItem('equipment_items')
    return saved ? JSON.parse(saved) : []
  })

  useEffect(() => {
    document.documentElement.lang = lang
    try { localStorage.setItem('go_lang', lang) } catch (_) {}
  }, [lang])

  useEffect(() => {
    const saved = localStorage.getItem('equipment_items')
    if (saved) {
      setUploadedItems(JSON.parse(saved))
    }
  }, [])

  const equipmentItems = [...equipmentItemsByLang[lang], ...uploadedItems]
  const t = {
    ...content[lang],
    equipment: {
      ...content[lang].equipment,
      items: equipmentItems
    }
  }

  const handleAddEquipment = (newItem) => {
    setEquipmentItemsByLang((prev) => ({
      ...prev,
      [lang]: [...(prev[lang] || []), newItem]
    }))
  }

  return (
    <Routes>
      <Route element={<PublicLayout t={t} lang={lang} setLang={setLang} year={year} />}>
        <Route path="/" element={<HomePage t={t} />} />
        <Route path="/about" element={<AboutPage t={t} />} />
        <Route path="/transport" element={<TransportPage t={t} lang={lang} />} />
        <Route path="/investment" element={<InvestmentPage lang={lang} />} />
        <Route path="/technology" element={<TechnologyPage lang={lang} />} />
        <Route path="/equipment" element={<EquipmentPage t={t} />} />
        <Route path="/equipment/:slug" element={<EquipmentItemPage t={t} />} />
        <Route path="/contact" element={<ContactPage t={t} />} />
        <Route path="/careers" element={<CareersPage t={t} lang={lang} />} />
      </Route>

      <Route
        path="/admin"
        element={<AdminDashboard items={equipmentItems} onAdd={handleAddEquipment} />}
      />
      <Route path="/logistics" element={<LogisticsDashboard />} />
      <Route path="/project-manager" element={<ProjectManagerDashboard />} />
      <Route path="/worker" element={<WorkerDashboard />} />
    </Routes>
  )
}

export default App
